import React, { createContext, FC, useContext } from 'react';

export const NodeConnectedPortsContext = createContext<Record<string, boolean> | undefined>(undefined);

interface NodeConnectedPortsContextProviderProps {
    connectedPorts?: Record<string, boolean>;
    children: React.ReactNode;
}

export const NodeConnectedPortsContextProvider: FC<NodeConnectedPortsContextProviderProps> = props => {
    return <NodeConnectedPortsContext.Provider value={props.connectedPorts}>{props.children}</NodeConnectedPortsContext.Provider>;
};

export function useIsNodePortConnected(): (portName: string) => boolean {
    const nodePortConnections = useContext(NodeConnectedPortsContext);
    return portName => nodePortConnections?.[portName] ?? false;
}
